import React from "react";
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View
} from "@react-pdf/renderer";

import GothamBold from "../../../../../../public/fonts/GothamBold.ttf";
import GothamBook from "../../../../../../public/fonts/GothamBook.ttf";

Font.register({
  family: "Gotham",
  fonts: [
    {
      src: GothamBold,
      fontWeight: 700
    },
    {
      src: GothamBook,
      fontWeight: 400
    }
  ]
});

const styles = StyleSheet.create({
  page: {
    alignItems: "center",
    backgroundColor: "#fff",
    flexDirection: "column",
    fontFamily: "Gotham",
    justifyContent: "center",
    padding: "1cm"
  },
  container: {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%"
  },
  logo: {
    height: 120,
    maxWidth: 360,
    objectFit: "contain"
  },
  qrCode: {
    height: 256,
    marginBottom: 24,
    width: 256
  },
  details: {
    alignItems: "center",
    flexDirection: "column",
    width: "100%"
  },
  providerName: {
    marginBottom: 8,
    width: "100%"
  },
  venueName: {
    marginBottom: 8,
    width: "100%"
  },
  primaryText: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.4,
    textAlign: "center"
  },
  secondaryText: {
    fontSize: 16,
    lineHeight: 1.4,
    textAlign: "center"
  },
  address: {
    fontSize: 16,
    lineHeight: 1.4,
    textAlign: "center"
  }
});

export interface QrCodeProvider {
  id: string;
  accountName: string;
  logo?: string | null;
}

interface QrCodeVenue {
  name: string;
  address?: string | null;
}

interface QrCodePdfProps {
  providers: QrCodeProvider[];
  qrData: string;
  venue: QrCodeVenue;
}

export const QrCodePdf = ({
  providers,
  qrData,
  venue
}: QrCodePdfProps) => (
  <Document>
    {providers.map(provider => (
      <Page key={provider.id} size="A4" style={styles.page}>
        <View style={styles.container}>
          {provider.logo && <Image src={provider.logo} style={styles.logo} />}
          <Image src={qrData} style={styles.qrCode} />
          <View style={styles.details}>
            <View style={styles.providerName}>
              <Text style={styles.secondaryText}>{provider.accountName}</Text>
            </View>
            <View style={styles.venueName}>
              <Text style={styles.primaryText}>{venue.name}</Text>
            </View>
            {venue.address && (
              <Text style={styles.address}>{venue.address}</Text>
            )}
          </View>
        </View>
      </Page>
    ))}
  </Document>
);
